  <div>
    <line-chart
      :chart-data="chartData"
      :options="chartOptions"
    />
  </div>

<script>
import { Line } from "vue-chartjs";

export default {
  extends: Line,

  props: {
    dataPoints: {
      type: Array,
      default: () => []
    },
    labels: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    labels() {
      this.renderChart(this.chartData, this.chartOptions);
    },
    dataPoints() {
      this.renderChart(this.chartData, this.chartOptions);
    }
  },

  computed: {
    chartData() {
      return {
        labels: this.labels,
        datasets: [
          {
            label: "Executions",
            backgroundColor: "rgba(54, 162, 235, 0.3)",
            borderColor: "#36A2EB",
            pointBackgroundColor: "#36A2EB",
            data: this.dataPoints
          }
        ]
      };
    },

    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              type: "category"
            }
          ],
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              }
            }
          ]
        }
      };
    }
  },

  mounted() {
    this.renderChart(this.chartData, this.chartOptions);
  }
};
</script>

<style scoped>
div {
  height: 350px;
}
</style>
